import {IQuestionAnswerType} from '../../incase-domain/elements/base/questionElementBase';

export const EMIT_TOAST = 'EMIT_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

export interface IEmitToast {
    type: typeof EMIT_TOAST;
    payload: {questionId: string; type: IQuestionAnswerType};
}

export interface IRemoveToast {
    type: typeof REMOVE_TOAST;
    payload: string;
}

export const emitToastAction = (payload: {questionId: string; type: IQuestionAnswerType}): IEmitToast => ({
    type: EMIT_TOAST,
    payload,
});

export const removeToastAction = (payload: string): IRemoveToast => ({
    type: REMOVE_TOAST,
    payload,
});
